import type { TSerializedWidget } from 'src/entities/workspace/types';
import type { FiltersWidgetEntity } from 'src/pages/dashboard/features/filters-widget/FiltersWidget.entity';
import { parseFiltersWidgetInternalState } from 'src/pages/dashboard/features/filters-widget/parseFiltersWidget';

import { baseWidgetApplyChanges } from './baseWidgetApplyChanges';

export function filtersApplyChanges(widget: FiltersWidgetEntity, changes: TSerializedWidget, index: number) {
  baseWidgetApplyChanges(widget, changes, index);

  const internalState = parseFiltersWidgetInternalState(changes.internalState);

  widget.setStateParams(internalState.stateParams);
}
